import { selectFromUserDto } from '../../models';

export default selectFromUserDto()
  .toString();
